<div>
  <nav class="navbar_nu" >
    <div class="left-data">
      <!---Burger Icon-->
      <div class="burger-menu-container" (mouseleave)="onMouseLeave($event)" #menuWrapper>
        <div class="burger-menu" (mouseenter)="toggleMenu(true)"  >
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
          <ul class="menu" *ngIf="isMenuOpen" (scroll)="onScroll($event)" >
            <ng-container *ngFor="let item of menuItems">
              <li *ngIf="!(item.Content == 'Work Queues') || ( item.Content == 'Work Queues' && workQueuesRoles.includes(formattedRole))" (mouseenter)="showSubMenu($event, item)" (mouseleave)="hideSubMenu(item)">
              
                <div class="menu-item" (click)="redirectView(item)"
                  [ngClass]="{'nav-item-active': selectedRoute == item.Url_Path, 'nav-main-item-active': parentRoute == item.Url_Path , 'has-submenu': item.submenus && item.submenus.length > 0}">
                <div class="left-menu-item">
                  <!--Icon-->
                  <img src="{{item.icon}}" class="menu-icon" alt="{{item.Content}} Icon" />
                  <!--Name-->
                  <span class="menu-name">{{item.Content}}</span>
                </div>
                
                <span class="menu-arrow" *ngIf="item.submenus && item.submenus.length > 0">
                  <mat-icon class="arrow-icon">{{item.showSubmenu ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
                </span>
                </div>
                
        
                
              </li>
            </ng-container>
          </ul>
          <!--Submenu-->
          <ul class="submenu" *ngIf="submenuList && submenuList.length > 0" (mouseleave)="onSubmenuMouseLeave()" [ngStyle]="{ top: submenuPosition.top + 'px', left: submenuPosition.left + 'px' }">
            <ng-container *ngFor="let subItem of submenuList">
              <li (click)="redirectView(subItem,true)" [ngClass]="{'nav-item-active': selectedRoute == subItem.Url_Path}">
                <div class="submenu-item">
                  <img src="{{subItem.icon}}" class="sub-menu-icon" alt="{{subItem.Content}} Icon" />
                  <span class="submenu-name">{{subItem.Content}}</span>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      
    
      <!--Logo-->
      <div class="navbar-brand pointer-event ps-3" (click)="redirectToHome()">
        <img class="header-logo" src="../../../../assets/imagesV4/menu-icons/techopshublogoimg.png" />
        {{appName}}
      </div>
    </div>
    

    <!--Right mat icons-->
    <div class="icons">
      <div class="contact_us_block  ms-4">
        <img src="assets/imagesV4/menu-icons/contactusimg.png" title="Contact US" class="contact_us_icon"
          (click)="redirectToContactUs()" alt="Contact Us Icon" />
      </div>
      <div class="documentation_block ms-4">
        <img src="assets/imagesV4/menu-icons/doc1.png" title="Documentation" class="documentation_icon"
          (click)="redirectToUserManual()" alt="Documentation Icon" />
      </div>
      <div class="release_notes_block img_block ms-4">
        <img src="assets/imagesV4/menu-icons/releasenotesimg.png" title="Release Notes" class="release_notes_icon"
          (click)="redirectToRelease()" alt="Release Notes Icon" />
      </div>
      <div class="nav-item dropdown ms-4">
        <span id="navbarDropdownMenuLink3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          [ngClass]="{'nav-item-active': selectedRoute == 'help'}">
          <img src="assets/imagesV4/menu-icons/notificationsimg.png" class="help-icon" />
          <div *ngIf="notifications.length>0" [ngClass]="{'redCircle': !genericNotificationOnly, 'greenCircle': genericNotificationOnly }"></div>
        </span>
        <div class="dropdown-menu dropdown-menu-right md-dropdown noti-dropdown"
          aria-labelledby="navbarDropdownMenuLink3">
          <div class="notification-header">Notifications</div>
          <section class="notification-content" *ngIf="notifications.length>0">
            <ng-container *ngFor="let eachNotificaation of notifications">
              <div class="notification">
                <div class="notification-title d-flex popup-title" 
                  *ngIf="eachNotificaation.Popup=='True'||eachNotificaation.Popup=='true'">
                  <p>{{eachNotificaation.Content}}</p>
                  <span class="pull-right notification-count" (click)="showNotificationPopup()">{{eachNotificaation.total_count}}</span>
                </div>
                <div class="notification-title d-flex"
                  *ngIf="eachNotificaation.Popup!='True'&& eachNotificaation.Popup!='true'">
                  <p>{{eachNotificaation.Content}}</p>
                  <span class="pull-right notification-count">{{eachNotificaation.total_count}}</span>
                </div>
  
                <ng-container *ngFor="let description of eachNotificaation.notifications">
                  <p class="notification-desc" [innerHTML]="description.Notification_message | safeHtml"></p>
                </ng-container>
  
              </div>
            </ng-container>
          </section>
          <section class="notification-content no-notification" *ngIf="notifications.length==0">
            <p>You have no notification right now</p>
          </section>
        </div>
      </div>
      <div class="user_name-initials ms-4 me-2" data-toggle="tooltip" data-placement="bottom"
      title="{{userNameFullDetails}}">{{userNameInitials}} </div>
    </div>

  </nav>
  <div class="stk-table-loader landing-page-header-loader" *ngIf="selectedRoute === 'landing-page' ? (landingHeaderLoaderStateService.loading$ | async) : showLoader">
    <app-loader>
    </app-loader>
  </div>
</div>
<app-modal [maximizable]="true" [inViewport]="true" #notificationModal class="modal-demo notification-popup">
  <ng-container class="app-modal-body ">
    <div class="d-flex close-icon" (click)="closeNotificationModal()"><mat-icon >close</mat-icon></div>
    <app-notification-popup [notificationList]="notificationList" *ngIf="showNotificationDetailPopup"></app-notification-popup>
  </ng-container>
</app-modal>
<app-modal [maximizable]="true" [inViewport]="true" #urgentActionReqModal class="urgent-action-popup">
  <ng-container class="app-modal-header">Urgent Action Required</ng-container>
  <ng-container class="app-modal-body ">
    <div *ngIf="oldBucketDetails.length>0" class="notification-details">
      <ng-container *ngFor="let urgentNotification of oldBucketDetails">
        <p class="notification-desc old-bucket" [innerHTML]="urgentNotification.Notification_message | safeHtml"></p>
      </ng-container>
    </div>
  </ng-container>
</app-modal>